import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'core/api/api.service';

export interface PowerBiEmbedConfig {
  embedToken: string;
  embedUrl: string;
  reportId: string;
  tokenExpiry: string;
}

@Injectable({ providedIn: 'root' })
export class PowerBiService {
  private readonly embedTokenUrl = '/api/powerbi/embedtoken';

  constructor(private apiService: ApiService) { }

  getEmbedConfig(): Observable<PowerBiEmbedConfig> {
    return this.apiService.get(this.embedTokenUrl);
  }
}
